import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Main from "../../layout/main";
import { StudentsService } from "../../services/competitions";
import AddStudentModal from "./AddStudentModal";
import DeleteStudentModal from "./DeleteStudentModal";
import Header from "../../components/common/secondary header/index";
import "./style.scss";
import { getMixpanelAdminType, Mixpanel } from "../../services/Mixpanel";
import * as configActions from "../../store/config/actions";
import { useDispatch } from "react-redux";
import { TEACHER } from "../../constants";
import { textIdentifier } from "../../textIdentifier";

const StudentsList = () => {
  const dispatch = useDispatch();
  const [showAdminOptions, setShowAdminOptions] = useState(false);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [showDeleteStudentModal, setShowDeleteStudentModal] = useState(false);

  const toggleShowAdminOptions = () => {
    setShowAdminOptions(!showAdminOptions);
  };

  const openAddStudentModal = () => {
    setShowAdminOptions(false);
    setShowAddStudentModal(!showAddStudentModal);
  };

  const openDeleteStudentModal = () => {
    setShowAdminOptions(false);
    setShowDeleteStudentModal(!showDeleteStudentModal);
  };

  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const { selectedCompetition, selectedSchool, selectedClass,lang } = useSelector(
    (state) => state.main
  );
  const { userData, userType } = useSelector((state) => state.auth);

  const fetchStudents = async () => {
    try {
      const res = await StudentsService(selectedClass?.code);
      setStudents(res.data);
      Mixpanel.track("Competition_Admin_Students_Viewed", {
        Admin_Type: getMixpanelAdminType(userData.groups),
        CompetitionID: selectedCompetition?.id,
        CompetitionName: selectedCompetition?.name,
        Class_id: selectedClass?.code,
      });
      Mixpanel.people.set({
        $email: userData?.email,
        $distinct_id: userData?.id,
      });
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    if (search) {
      setFilteredStudents(
        students.filter(
          (student) =>
            (
              student.first_name?.toLowerCase() +
              " " +
              student.last_name?.toLowerCase()
            ).includes(search.toLowerCase()) ||
            student.email?.toLowerCase().includes(search.toLowerCase())
        )
      );
    } else {
      setFilteredStudents(students);
    }
  }, [students, search]);

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool || !selectedClass) {
      navigate(`/`);
    } else {
      fetchStudents();
    }
  }, []);

  useEffect(() => {
    setFilteredStudents(students);
  }, [students]);

  useEffect(() => {
    if (!showAddStudentModal || !showDeleteStudentModal) {
      fetchStudents();
    }
  }, [showAddStudentModal, showDeleteStudentModal]);

  const startTime = new Date(selectedCompetition?.start_time);
  const endTime = new Date(selectedCompetition?.end_time);

  const renderTimeStringJSX = (start_time, end_time) => {
    const startTime = new Date(start_time);
    const endTime = new Date(end_time);

    function getDateString(date) {
      const d = new Date(date).toJSON();
      return d.split("T")[0].split("-").reverse().join("-");
    }

    return (
      <Fragment>
        <span>{getDateString(startTime)} </span>
        <span className="text-primary">
          {startTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
        <span>to </span>
        <span>{getDateString(endTime)} </span>
        <span className="text-primary">
          {endTime
            .toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            })
            .toLowerCase()}{" "}
        </span>
      </Fragment>
    );
  };

  if (isFetching) {
    return <Header />;
  }
  return (
    <Fragment>
      <Header />

      <Main className={"competition-schools-class-students"}>
        <div className="cr-wrapper-card mx-auto">
          <div className="cr-card-header justify-content-start">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 35 35"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.78 3.66699H10.2213C6.1933 3.66699 3.66797 6.51899 3.66797 10.555V21.4457C3.66797 25.4817 6.17997 28.3337 10.2213 28.3337H21.7786C25.82 28.3337 28.3346 25.4817 28.3346 21.4457V10.555C28.3346 6.51899 25.82 3.66699 21.78 3.66699Z"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 11V16.3333L20 20.3333"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{textIdentifier['from'][lang]} :</span>
            </div>

            <div>{renderTimeStringJSX(startTime, endTime)}</div>
          </div>

          <ol className="breadcrumb">
            <li
              className="breadcrumb-item"
              onClick={() => navigate(`/schools`)}
            >
              <span>{selectedCompetition?.name}</span>
            </li>

            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="24"
                viewBox="0 0 14 30"
                fill="none"
              >
                <path
                  d="M4.45149 28.6315C4.27728 29.2166 3.95371 29.5946 3.48083 29.7652C3.03283 29.9603 2.57238 29.9846 2.09949 29.8383C1.65149 29.7164 1.30305 29.4604 1.05416 29.0703C0.780383 28.6803 0.743049 28.1804 0.942161 27.5709L9.56616 1.34919C9.76528 0.764046 10.0888 0.373955 10.5368 0.178903C10.9848 -0.0161448 11.4328 -0.0405265 11.8808 0.105759C12.3537 0.227669 12.7146 0.495852 12.9635 0.910332C13.2373 1.30042 13.2746 1.78805 13.0755 2.37319L4.45149 28.6315Z"
                  fill="#2E2E2E"
                />
              </svg>
            </li>

            <li
              className="breadcrumb-item d-flex align-items-center"
              aria-current="page"
              onClick={() => navigate(`/schools/${selectedSchool?.id}/classes`)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  d="M7.66667 15.6667V19.6667V15.6667ZM13 15.6667V19.6667V15.6667ZM18.3333 15.6667V19.6667V15.6667ZM1 25H25H1ZM1 10.3333H25H1ZM1 6.33333L13 1L25 6.33333H1ZM2.33333 10.3333H23.6667V25H2.33333V10.3333Z"
                  stroke="#0059B1"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{selectedSchool?.name}</span>
            </li>

            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="24"
                viewBox="0 0 14 30"
                fill="none"
              >
                <path
                  d="M4.45149 28.6315C4.27728 29.2166 3.95371 29.5946 3.48083 29.7652C3.03283 29.9603 2.57238 29.9846 2.09949 29.8383C1.65149 29.7164 1.30305 29.4604 1.05416 29.0703C0.780383 28.6803 0.743049 28.1804 0.942161 27.5709L9.56616 1.34919C9.76528 0.764046 10.0888 0.373955 10.5368 0.178903C10.9848 -0.0161448 11.4328 -0.0405265 11.8808 0.105759C12.3537 0.227669 12.7146 0.495852 12.9635 0.910332C13.2373 1.30042 13.2746 1.78805 13.0755 2.37319L4.45149 28.6315Z"
                  fill="#2E2E2E"
                />
              </svg>
            </li>

            <li
              className="breadcrumb-item  active d-flex align-items-center"
              aria-current="page"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
              >
                <path
                  d="M7.66667 22.6673V12.6673L13 9.70465M13 14.6673L25 8.00065L13 1.33398L1 8.00065L13 14.6673ZM13 14.6673L21.2133 10.1047C22.294 12.8488 22.6007 15.8369 22.1 18.7433C18.7181 19.0716 15.5296 20.4721 13 22.7407C10.4707 20.4724 7.28278 19.0718 3.90133 18.7433C3.40027 15.8369 3.70698 12.8487 4.788 10.1047L13 14.6673Z"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>{selectedClass?.code}</span>
            </li>
          </ol>

          <div className="cr-card">
            <div
              className="header"
              style={{ justifyContent: "flex-end", gap: "40px" }}
            >
              <div className="d-flex" style={{ gap: "42px" }}>
                <div className="cr-search-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M19 19L13 13L19 19ZM15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                      stroke="#2E2E2E"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <input
                    className="form-control w-100"
                    placeholder={textIdentifier["search-by-name-or-email"][lang]}
                    name="searchByName"
                    id="searchByName"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>
              </div>

              {userType !== TEACHER && (
                <div className="dropdown">
                  <button
                    className="btn btn-outlined dropdown-toggle mb-0"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    data-bs-offset="0,15"
                    aria-expanded="false"
                    onClick={toggleShowAdminOptions}
                  >
                    <span>{textIdentifier["admin-options"][lang]}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 13 8"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.351832 0.7516C0.576865 0.526635 0.882035 0.400256 1.20023 0.400256C1.51843 0.400256 1.8236 0.526635 2.04863 0.7516L6.00023 4.7032L9.95183 0.7516C10.0625 0.636988 10.1949 0.545569 10.3413 0.482678C10.4878 0.419787 10.6452 0.386684 10.8046 0.385299C10.9639 0.383915 11.1219 0.414276 11.2694 0.474613C11.4169 0.534951 11.5508 0.624054 11.6635 0.736726C11.7762 0.849397 11.8653 0.983379 11.9256 1.13085C11.986 1.27833 12.0163 1.43635 12.0149 1.59568C12.0135 1.75502 11.9804 1.91248 11.9176 2.05888C11.8547 2.20529 11.7632 2.3377 11.6486 2.4484L6.84863 7.2484C6.6236 7.47336 6.31843 7.59974 6.00023 7.59974C5.68204 7.59974 5.37687 7.47336 5.15183 7.2484L0.351832 2.4484C0.126867 2.22337 0.000488281 1.9182 0.000488281 1.6C0.000488281 1.2818 0.126867 0.976633 0.351832 0.7516Z"
                        fill="#0059B1"
                      />
                    </svg>
                  </button>

                  {showAdminOptions && (
                    <ul
                      className="dropdown-menu show"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li onClick={openAddStudentModal}>
                        <Link
                          data-bs-toggle="modal"
                          data-bs-target="#addStudentModal"
                          className="dropdown-item"
                          to="#addStudentModal"
                        >
                          {textIdentifier['add-student'][lang]}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 34 34"
                            fill="none"
                          >
                            <path
                              d="M27.5 11.75V17V11.75ZM27.5 17V22.25V17ZM27.5 17H32.75H27.5ZM27.5 17H22.25H27.5ZM18.75 8.25C18.75 10.1065 18.0125 11.887 16.6997 13.1997C15.387 14.5125 13.6065 15.25 11.75 15.25C9.89348 15.25 8.11301 14.5125 6.80025 13.1997C5.4875 11.887 4.75 10.1065 4.75 8.25C4.75 6.39348 5.4875 4.61301 6.80025 3.30025C8.11301 1.9875 9.89348 1.25 11.75 1.25C13.6065 1.25 15.387 1.9875 16.6997 3.30025C18.0125 4.61301 18.75 6.39348 18.75 8.25V8.25ZM1.25 31C1.25 28.2152 2.35625 25.5445 4.32538 23.5754C6.29451 21.6062 8.96523 20.5 11.75 20.5C14.5348 20.5 17.2055 21.6062 19.1746 23.5754C21.1438 25.5445 22.25 28.2152 22.25 31V32.75H1.25V31Z"
                              stroke="#2E2E2E"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Link>
                      </li>

                      <li onClick={openDeleteStudentModal}>
                        <Link
                          data-bs-toggle="modal"
                          data-bs-target="#deleteStudentModal"
                          className="dropdown-item"
                          to="#deleteStudentModal"
                        >
                          {textIdentifier["delete-student"][lang]}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 30 34"
                            fill="none"
                          >
                            <path
                              d="M1 8.25H29M27.25 8.25L25.7327 29.4985C25.6699 30.3815 25.2748 31.2079 24.6269 31.8113C23.9791 32.4146 23.1268 32.75 22.2415 32.75H7.7585C6.87324 32.75 6.02087 32.4146 5.37305 31.8113C4.72523 31.2079 4.3301 30.3815 4.26725 29.4985L2.75 8.25H27.25ZM11.5 15.25V25.75V15.25ZM18.5 15.25V25.75V15.25ZM20.25 8.25V3C20.25 2.53587 20.0656 2.09075 19.7374 1.76256C19.4092 1.43437 18.9641 1.25 18.5 1.25H11.5C11.0359 1.25 10.5908 1.43437 10.2626 1.76256C9.93437 2.09075 9.75 2.53587 9.75 3V8.25H20.25Z"
                              stroke="#2E2E2E"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </Link>
                      </li>
                    </ul>
                  )}
                </div>
              )}
            </div>

            <div className="header list-header-container">
              <div className="flex-items">
                <span>{textIdentifier['no'][lang]}.</span>
                <span>{textIdentifier['student-name'][lang]}</span>
                <span>{textIdentifier['email'][lang]}</span>
              </div>
            </div>
            <ul className="list-group">
              {filteredStudents.map((student, index) => (
                <React.Fragment key={student.id}>
                  <li className="list-group-item list-item">
                    <div className="flex-items">
                      <span>{index + 1}</span>
                      <span>
                        {student.first_name} {student.last_name}
                      </span>
                      <span>{student.email}</span>
                    </div>
                  </li>
                  <hr className="underline" />
                </React.Fragment>
              ))}
              <li className="list-group-item list-item">
                <div className="flex-items">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="24"
                    viewBox="0 0 30 24"
                    fill="none"
                  >
                    <path
                      d="M21.666 22.6673H28.3327V20.0006C28.3326 19.1694 28.0736 18.3587 27.5915 17.6815C27.1095 17.0042 26.4284 16.494 25.643 16.2217C24.8576 15.9493 24.0068 15.9285 23.209 16.162C22.4112 16.3955 21.706 16.8718 21.1913 17.5246M21.666 22.6673L21.1913 17.5246M21.666 22.6673H8.33268M21.666 22.6673V20.0006C21.666 19.126 21.498 18.29 21.1913 17.5246M21.1913 17.5246C20.6962 16.2873 19.8417 15.2266 18.738 14.4795C17.6343 13.7324 16.3321 13.333 14.9993 13.333C13.6666 13.333 12.3644 13.7324 11.2607 14.4795C10.157 15.2266 9.30249 16.2873 8.80735 17.5246M8.33268 22.6673H1.66602V20.0006C1.66608 19.1694 1.92513 18.3587 2.40716 17.6815C2.8892 17.0042 3.57026 16.494 4.35568 16.2217C5.1411 15.9493 5.99185 15.9285 6.78967 16.162C7.58748 16.3955 8.29272 16.8718 8.80735 17.5246M8.33268 22.6673L8.80735 17.5246M8.33268 22.6673V20.0006C8.33268 19.126 8.50068 18.29 8.80735 17.5246M18.9993 5.33398C18.9993 6.39485 18.5779 7.41227 17.8278 8.16241C17.0776 8.91256 16.0602 9.33398 14.9993 9.33398C13.9385 9.33398 12.9211 8.91256 12.1709 8.16241C11.4208 7.41227 10.9993 6.39485 10.9993 5.33398C10.9993 4.27312 11.4208 3.2557 12.1709 2.50556C12.9211 1.75541 13.9385 1.33398 14.9993 1.33398C16.0602 1.33398 17.0776 1.75541 17.8278 2.50556C18.5779 3.2557 18.9993 4.27312 18.9993 5.33398ZM26.9993 9.33398C26.9993 10.0412 26.7184 10.7195 26.2183 11.2196C25.7182 11.7197 25.0399 12.0007 24.3327 12.0007C23.6254 12.0007 22.9472 11.7197 22.4471 11.2196C21.947 10.7195 21.666 10.0412 21.666 9.33398C21.666 8.62674 21.947 7.94846 22.4471 7.44837C22.9472 6.94827 23.6254 6.66732 24.3327 6.66732C25.0399 6.66732 25.7182 6.94827 26.2183 7.44837C26.7184 7.94846 26.9993 8.62674 26.9993 9.33398ZM8.33268 9.33398C8.33268 10.0412 8.05173 10.7195 7.55163 11.2196C7.05154 11.7197 6.37326 12.0007 5.66602 12.0007C4.95877 12.0007 4.28049 11.7197 3.7804 11.2196C3.2803 10.7195 2.99935 10.0412 2.99935 9.33398C2.99935 8.62674 3.2803 7.94846 3.7804 7.44837C4.28049 6.94827 4.95877 6.66732 5.66602 6.66732C6.37326 6.66732 7.05154 6.94827 7.55163 7.44837C8.05173 7.94846 8.33268 8.62674 8.33268 9.33398Z"
                      stroke="#2E2E2E"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="m-0 font-weight-bold">
                    {textIdentifier["total-students"][lang]} : {filteredStudents.length}
                  </span>
                </div>
              </li>
              <hr className="underline" />
            </ul>
          </div>
        </div>
      </Main>
      {/*  add student modal  */}
      {showAddStudentModal && (
        <AddStudentModal setShowAddStudentModal={setShowAddStudentModal} />
      )}

      {/*  delete student modal */}
      {showDeleteStudentModal && (
        <DeleteStudentModal
          students={students}
          setShowDeleteStudentModal={setShowDeleteStudentModal}
        />
      )}

      {(showAddStudentModal || showDeleteStudentModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </Fragment>
  );
};

export default StudentsList;
